import { render, staticRenderFns } from "./Zone.vue?vue&type=template&id=3c37b468&scoped=true&"
import script from "./Zone.vue?vue&type=script&lang=js&"
export * from "./Zone.vue?vue&type=script&lang=js&"
import style0 from "./Zone.vue?vue&type=style&index=0&id=3c37b468&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c37b468",
  null
  
)

export default component.exports